// extracted by mini-css-extract-plugin
export const main = "index-module--main--X-C1v";
export const loading = "index-module--loading--2bid-";